import React from 'react';
import { IconProps } from './types/Icon.type';

function RadioDisabledBlankIcon(props: IconProps) {
  return (
    <svg
      width={props.boxSize ?? '24'}
      height={props.boxSize ?? '24'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="20" height="20" rx="10" fill="#F7F7F7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#E2E2E2"
      />
    </svg>
  );
}

export default RadioDisabledBlankIcon;
